import React from 'react';
import { Box } from '@curves/ui-base';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { OverviewProvider } from './OverviewContext';
import OverviewListTable from './OverviewListTable';
import OverviewListSearchBarLayout from './OverviewListSearchBarLayout';
import OverviewListSummary from './OverviewListSummary';
/**
 * OverviewListLayout 是一個專為總覽列表頁設計的排版元件，用來組合常見的查詢與呈現區塊。
 *
 * 排版順序固定如下：
 * ├── OverviewListLayout.SearchBar （可選）
 * ├── OverviewListLayout.Summary （可選）
 * ├── OverviewListLayout.Table （必填，否則無顯示意義）
 *
 * 設計目的：
 * - 統一列表頁結構
 * - 透過 context 傳遞查詢狀態或篩選條件
 * - 根據需求靈活組合 SearchBar 和 Summary
 *
 * @component
 * @param {Object} props - 組件的傳入參數
 * @param {string} [props.className] - 外層容器的自定義 class
 * @param {React.ReactNode} props.children - 子元件，需包含至少一個 OverviewListLayout.Table
 * @param {Object} [props.contextValue] - 透過 context 傳入的值，用於共享列表狀態
 *
 * @example
 * <OverviewListLayout contextValue={ctx}>
 *   <OverviewListLayout.SearchBar />
 *   <OverviewListLayout.Summary />
 *   <OverviewListLayout.Table />
 * </OverviewListLayout>
 *
 * @throws 若未使用 `OverviewListLayout.Table`，此元件不會有實質顯示內容。
 */
const OverviewListLayout = ({ className, children, contextValue, ...rest }) => {
    return (
        <OverviewProvider value={contextValue}>
            <Box className={clsx('overview-list', className)} {...rest}>
                {children}
            </Box>
        </OverviewProvider>
    );
};
OverviewListLayout.SearchBar = OverviewListSearchBarLayout;
OverviewListLayout.Summary = OverviewListSummary;
OverviewListLayout.Table = OverviewListTable;
OverviewListLayout.propTypes = {
    className: PropTypes.string,
    contextValue: PropTypes.object,
    children: PropTypes.node,
};
export default OverviewListLayout;
